<skl-dialog-content-ins [isReady]="viewModel.isFormReady">
    <skl-dialog-header-ins
        [title]="'scenes.shared.dialog.product.title' | translate"
        id="product-dialog-header"
        (onClose)="onCancel()">
    </skl-dialog-header-ins>

    <ins-content>
        <skl-form-container>
            @if (viewModel.isFormReady) {
                <div class="grid" [sklValidationSource]="viewValidation">

                    <div class="col-1">
                        <div class="col-1-3">
                            <ins-form-field
                                [label]="'scenes.shared.dialog.product.kind.label' | translate">
                                <ins-select
                                    id="product-dialog-kind"
                                    [disabled]="viewModel.isInventoryDocument"
                                    display-text="label"
                                    [converter]="viewModel.productKindValueConverter"
                                    [(ngModel)]="viewModel.bo.model.kind">
                                    @for (item of viewModel.productKinds; track item) {
                                        <ins-option
                                            [value]="item">
                                            {{ item.label }}
                                        </ins-option>
                                    }
                                </ins-select>
                            </ins-form-field>
                        </div>
                        @if (viewModel.inventorySectionActive()) {
                            <div class="col-2-3 align--checkbox">
                                <div class="display--flex inventory-control">
                                    <ins-checkbox
                                        id="product-dialog-inventory-control"
                                        [disabled]="viewModel.isInventoryControlDisabled"
                                        [(ngModel)]="viewModel.bo.model.inventoryControl"
                                        [label]="'scenes.products.form.fields.inventory-control.label' | translate"
                                        [sklValidate]="getValidationKey('inventoryControl')">
                                    </ins-checkbox>
                                    <div>
                                        <skl-icon
                                            [tooltip]="'scenes.products.form.fields.inventory-control.placeholder' | translate"
                                            class="icon--clickable"
                                            color="secondary"
                                            shape="circle"
                                            name="help">
                                        </skl-icon>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div class="col-1">
                        <div class="col-1-3">
                            <ins-form-field
                                [label]="'scenes.products.form.fields.symbol.label' | translate">
                                <ins-input
                                    id="product-dialog-symbol"
                                    [skl-focus-by]
                                    [skl-focus-by-trigger]="viewModel.isFormReady"
                                    [(ngModel)]="viewModel.bo.model.symbol"
                                    [placeholder]="'scenes.products.form.fields.symbol.placeholder' | translate"
                                    [sklValidate]="getValidationKey('symbol')">
                                </ins-input>
                            </ins-form-field>
                        </div>
                        <div class="col-1-3">
                            <ins-form-field
                                [label]="'scenes.products.form.fields.name.label' | translate">
                                <ins-textarea
                                    id="product-dialog-name"
                                    class="display--full-width"
                                    [multiline]="true"
                                    [(ngModel)]="viewModel.bo.model.name"
                                    [placeholder]="'scenes.products.form.fields.name.placeholder' | translate"
                                    [sklValidate]="getValidationKey('name')">
                                </ins-textarea>
                            </ins-form-field>
                        </div>
                        <div class="col-1-3">
                            <ins-form-field [label]="'scenes.products.form.fields.unit.label' | translate">
                                <ins-select
                                    id="product-dialog-unit"
                                    display-text="name"
                                    [converter]="viewModel.unitValueConverter"
                                    [(ngModel)]="viewModel.bo.model.unitId"
                                    [sklValidate]="getValidationKey('unitId')">
                                    @for (item of viewModel.units; track item) {
                                        <ins-option
                                            [value]="item">
                                            {{ item.name }}
                                        </ins-option>
                                    }
                                </ins-select>
                                <div slot="end">
                                    <skl-icon
                                        [sklValidateInner]="{key: getValidationKey('unitId'), option: 'hide'}"
                                        id="product-dialog-add-unit-button"
                                        [tooltip]="{
                                            color: 'success',
                                            text: 'scenes.products.form.fields.unit.add-button-text' | translate
                                        }"
                                        class="icon--clickable"
                                        color="success"
                                        shape="circle"
                                        name="plus"
                                        (click)="addUnitAsync()">
                                    </skl-icon>
                                </div>
                            </ins-form-field>
                        </div>
                    </div>
                    <div class="col-1">
                        @if (viewModel.priceKind === 'sale') {
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.vat-rate.label' | translate">
                                    <ins-select
                                        id="product-dialog-vat-rate"
                                        display-text="name"
                                        [converter]="viewModel.vatRateValueConverter"
                                        [(ngModel)]="viewModel.bo.model.vatRateId"
                                        [sklValidate]="getValidationKey('vatRateId')">
                                        @for (item of viewModel.vatRates; track item) {
                                            <ins-option
                                                [value]="item">
                                                {{ item.name }}
                                            </ins-option>
                                        }
                                    </ins-select>
                                </ins-form-field>
                            </div>
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.net-price.label' | translate">
                                    <ins-input
                                        id="product-dialog-sale-price-net"
                                        inputmode="decimal"
                                        [(ngModel)]="viewModel.salePrice.price.net"
                                        [precision]="viewModel.salePrice.precision"
                                        [sklValidate]="'net.' + viewModel.salePrice.price.sun">
                                    </ins-input>
                                    <div
                                        slot="end"
                                        [sklValidateInner]="{key: 'net.' + viewModel.salePrice.price.sun, option: 'disable'}">
                                        {{ viewModel.salePrice.symbol }}
                                    </div>
                                </ins-form-field>
                            </div>
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.gross-price.label' | translate">
                                    <ins-input
                                        id="product-dialog-sale-price-gross"
                                        inputmode="decimal"
                                        [(ngModel)]="viewModel.salePrice.price.gross"
                                        [precision]="viewModel.salePrice.precision"
                                        [sklValidate]="'gross.' + viewModel.salePrice.price.sun">
                                    </ins-input>
                                    <div
                                        slot="end"
                                        [sklValidateInner]="{key: 'gross.' + viewModel.salePrice.price.sun, option: 'disable'}">
                                        {{ viewModel.salePrice.symbol }}
                                    </div>
                                </ins-form-field>
                            </div>

                        } @else if (viewModel.priceKind === 'purchase') {
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.vat-rate.label' | translate">
                                    <ins-select
                                        id="product-dialog-vat-rate"
                                        display-text="name"
                                        [converter]="viewModel.purchaseVatRateValueConverter"
                                        [(ngModel)]="viewModel.bo.model.purchaseVatRateId"
                                        [sklValidate]="getValidationKey('purchaseVatRateId')">
                                        @for (item of viewModel.purchaseVatRates; track item) {
                                            <ins-option
                                                [value]="item">
                                                {{ item.name }}
                                            </ins-option>
                                        }
                                    </ins-select>
                                </ins-form-field>
                            </div>
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.purchase-prices.net.label' | translate">
                                    <ins-input
                                        id="product-dialog-purchase-price-net"
                                        inputmode="decimal"
                                        [(ngModel)]="viewModel.bo.model.purchasePrice.net"
                                        [precision]="viewModel.baseCurrency.precision"
                                        [placeholder]="'scenes.products.form.fields.purchase-prices.net.placeholder' | translate"
                                        [sklValidate]="'net.' + viewModel.bo.model.purchasePrice.sun">
                                    </ins-input>
                                    <div
                                        slot="end"
                                        [sklValidateInner]="{key: 'net.' + viewModel.bo.model.purchasePrice.sun, option: 'disable'}">
                                        {{ viewModel.baseCurrency.symbol }}
                                    </div>
                                </ins-form-field>
                            </div>
                            <div class="col-1-3">
                                <ins-form-field
                                    [label]="'scenes.products.form.fields.purchase-prices.gross.label' | translate">
                                    <ins-input
                                        id="product-dialog-purchase-price-gross"
                                        inputmode="decimal"
                                        [(ngModel)]="viewModel.bo.model.purchasePrice.gross"
                                        [precision]="viewModel.baseCurrency.precision"
                                        [placeholder]="'scenes.products.form.fields.purchase-prices.gross.placeholder' | translate"
                                        [sklValidate]="'gross.' + viewModel.bo.model.purchasePrice.sun">
                                    </ins-input>
                                    <div
                                        slot="end"
                                        [sklValidateInner]="{key: 'gross.' + viewModel.bo.model.purchasePrice.sun, option: 'disable'}">
                                        {{ viewModel.baseCurrency.symbol }}
                                    </div>
                                </ins-form-field>
                            </div>
                        }
                    </div>
                </div>
            }
        </skl-form-container>
    </ins-content>
    <ins-footer class="dialog__buttons">
        <skl-button
            id="product-dialog-cancel-button"
            (click)="onCancel()">
            {{ 'scenes.shared.dialog.product.buttons.cancel' | translate }}
        </skl-button>
        <skl-button
            id="product-dialog-save-button"
            typeName="accent"
            [spinner]="viewModel.isSaving"
            (click)="saveAsync()">
            {{ 'scenes.shared.dialog.product.buttons.save' | translate }}
        </skl-button>
    </ins-footer>
</skl-dialog-content-ins>
